// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3Tvrt","inputDescription":"styles_inputDescription__mTix6"};